import store from '@/store';

export default (to, from, next) => {
    const is_voucher_allowed = store.getters.is_app_environment_enabled_voucher_menu_item;

    return {
        allow: is_voucher_allowed,
        redirect: { name: 'not-found' },
    }
};
